





















































































import {Component, Vue} from 'vue-property-decorator';
import _ from 'lodash';
import ObjectLayer from "@/components/ObjectLayer.vue";

declare type Point2D = {
  x: number, y: number
}

declare type Movement = {
  x: number, y: number
}

const clearElementSelection: Function = ((): any => {
  // @ts-ignore
  if ((<Window>window).getSelection) {
    // @ts-ignore
    if (window.getSelection()!.empty) {  // Chrome
      return () => {
        window.getSelection()!.empty();
      };
      // @ts-ignore
    } else if (window.getSelection()!.removeAllRanges) {  // Firefox
      return () => {
        window.getSelection()!.removeAllRanges();
      };
    }
    // @ts-ignore
  } else if (<Document>document.selection!) {  // IE
    return () => {
    // @ts-ignore
      document.selection!.empty();
    };
  } else {
    return () => {
    }
  }
})();


const INITIAL_ZOOM = 50;
const ZOOM_THRESHOLD = 0.05;
const ZOOM_THRESHOLD_SCALE_UP = Math.pow((1 + ZOOM_THRESHOLD), 2);
const ZOOM_THRESHOLD_SCALE_DOWN = Math.pow((1 + ZOOM_THRESHOLD), -2);

const ZOOM_LEVEL: number[] = _.map(_.range(-1 * INITIAL_ZOOM, 150), (n: number) => {
  return Math.pow(1 + ZOOM_THRESHOLD, n)
});
ZOOM_LEVEL[INITIAL_ZOOM] = 1.0;

declare type ZoomDirection = '' | 'up' | 'down';

@Component({
  components: {
    'object-layer': ObjectLayer
  },
})
export default class App extends Vue {
  tm(e: TouchEvent) {
    if (this.touchable) {
      this.touchmove(e);
    } else {

    }
  }

  ts(e: TouchEvent) {
    if (this.touchable) {
      this.touchstart(e);
    } else {

    }
  }

  te(e: TouchEvent) {
    if (this.touchable) {
      this.touchend(e);
    } else {

    }
  }

  tsp(e: PointerEvent) {
    if (this.touchable) {

    } else {
      this.touchstartP(e);
    }
  }

  tep(e: PointerEvent) {
    if (this.touchable) {

    } else {
      this.touchendP(e)
    }
  }

  tmp(e: PointerEvent) {
    if (this.touchable) {

    } else {
      this.touchmoveP(e);
    }
  }

  noop() {
    console.log('noop');
  }

  get touchable(): boolean {
    return navigator.maxTouchPoints > 1;
  }

  touches: { id: number, clientX: number, clientY: number }[] = [];

  draw_origin: Point2D = {x: 0, y: 0};
  current_zoom: number = ZOOM_LEVEL[INITIAL_ZOOM];
  zoom_standard = -1;

  pan(deltaX: number, deltaY: number): void {
    this.draw_origin.x += deltaX;
    this.draw_origin.y += deltaY;
  }

  map_dragging: boolean = false;

  pinch_start_point: Point2D = {x: 240, y: 300}
  last_touch_point: Point2D = {x: 0, y: 0}

  reload(): void {
    location.reload();
  }

  wheel(e: WheelEvent): void {

    let zoom_up: boolean = true;
    if (e.deltaY > 0) {
      zoom_up = false;
    }

    this.change_zoom(zoom_up, e.clientX, e.clientY);
  }

  zoom_level: number = INITIAL_ZOOM;

  change_zoom(zoom_up: boolean, center_x: number, center_y: number) {
    const zoom_value_before = (() => {
      return this.current_zoom
    })();

    let zoom_level = this.zoom_level;
    if (zoom_up) {
      zoom_level = Math.min(ZOOM_LEVEL.length - 1, zoom_level + 1);
    } else {
      zoom_level = Math.max(0, zoom_level - 1);
    }

    this.current_zoom = ZOOM_LEVEL[zoom_level];
    this.zoom_level = zoom_level;

    const mouse_position: Point2D = {x: center_x, y: center_y};
    const draw_origin: Point2D = this.draw_origin;
    const zoom_value_after: number = this.current_zoom;
    const zoom_delta_ratio: number = zoom_value_after / zoom_value_before * -1;

    this.draw_origin = {
      x: Math.round((mouse_position.x - draw_origin.x) * zoom_delta_ratio + mouse_position.x),
      y: Math.round((mouse_position.y - draw_origin.y) * zoom_delta_ratio + mouse_position.y)
    };
  }

  camera_history: { x: number, y: number, zoom: number, id: number }[] = [];

  index_ = 0;

  load_camera(index: number): void {
    this.draw_origin.x = this.camera_history[index].x;
    this.draw_origin.y = this.camera_history[index].y;
    this.current_zoom = this.camera_history[index].zoom;
  }

  save_camera(): void {
    this.index_ += 1;
    this.camera_history.push(
        {
          x: this.draw_origin.x,
          y: this.draw_origin.y,
          zoom: this.current_zoom,
          id: this.index_
        }
    )
  }

  touchstart(e: TouchEvent): void {
    this.map_dragging = true;
    this.last_touch_point = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY
    }
  }

  touchstartP(e: PointerEvent): void {
    this.map_dragging = true;
    this.last_touch_point = {
      x: e.clientX,
      y: e.clientY
    }
  }

  touchend(e: TouchEvent): void {
    this.map_dragging = false;
    this.pinching = false;
    this.touches = [];
  }

  touchendP(e: PointerEvent): void {
    this.map_dragging = false;
  }

  touch_count: number = 0;

  touchmoveP(e: PointerEvent): void {
    if (this.map_dragging) {
      this.draw_origin.x += e.movementX;
      this.draw_origin.y += e.movementY;
    }
  }

  pinching: boolean = false;

  last_zoom_direction: ZoomDirection = '';

  touchmove(e: TouchEvent): void {
    if (e.touches.length === 1) {
      if (this.map_dragging) {
        if (this.touch_count === 1) {
          this.draw_origin.x += (e.touches[0].clientX - this.last_touch_point.x);
          this.draw_origin.y += (e.touches[0].clientY - this.last_touch_point.y);
        }
        this.last_touch_point = {x: e.touches[0].clientX, y: e.touches[0].clientY};
      }
      this.touch_count = 1;
      this.pinching = false;

      this.pinch_start_point = {
        x: this.last_touch_point.x,
        y: this.last_touch_point.y
      }
    } else {
      //　指2本以上によるタッチ

      // パン操作
      const touch_center: Point2D = {
        x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
        y: (e.touches[0].clientY + e.touches[1].clientY) / 2
      }

      this.last_touch_point = touch_center;

      // ピンチ操作
      const next_zoom_standard: number = Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) + Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2);

      if (!this.pinching) {
        this.pinch_start_point.x = touch_center.x;
        this.pinch_start_point.y = touch_center.y;

        this.pinching = true;
      }

      if (next_zoom_standard > this.zoom_standard * ZOOM_THRESHOLD_SCALE_UP) {
        this.change_zoom(true, this.pinch_start_point.x, this.pinch_start_point.y);
        this.zoom_standard = next_zoom_standard;
        this.last_zoom_direction = 'up';
      } else if (next_zoom_standard < this.zoom_standard * ZOOM_THRESHOLD_SCALE_DOWN) {
        this.change_zoom(false, this.pinch_start_point.x, this.pinch_start_point.y);
        this.zoom_standard = next_zoom_standard;
        this.last_zoom_direction = 'down';
      }

      this.touch_count = e.touches.length;
    }

    this.touches = _.map(e.touches, (t) => {
      return {
        id: t.identifier,
        clientX: Math.floor(t.clientX),
        clientY: Math.floor(t.clientY),
      };
    });

    clearElementSelection();
  }
}
